export type AlertActions =
  | {
      type: "SHOW_ALERT";
      payload: Omit<AlertState, "show">;
    }
  | { type: "HIDE_ALERT" };

export type AlertState = {
  show: boolean;
  title: string;
  message: string;
  icon?: string;
  autoCloseMs?: number;
};

export const initialState: AlertState = {
  show: false,
  title: "",
  message: "",
  icon: "",
};

export const alertStateReducer = (state: AlertState, action: AlertActions) => {
  switch (action.type) {
    case "SHOW_ALERT": {
      return { ...initialState, ...action.payload, show: true };
    }
    case "HIDE_ALERT": {
      return initialState;
    }
    default: {
      throw new Error(`Unhandled action type: ${action}`);
    }
  }
};
